var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2777 15.9375C15.2777 16.0867 15.2184 16.2298 15.1129 16.3352C15.0074 16.4407 14.8643 16.5 14.7152 16.5H3.28516C3.13597 16.5 2.9929 16.4407 2.88741 16.3352C2.78192 16.2298 2.72266 16.0867 2.72266 15.9375C2.72266 12.8625 6.09766 10.4775 9.00016 10.4775C11.9027 10.4775 15.2777 12.8625 15.2777 15.9375ZM12.8252 5.3325C12.8237 6.08869 12.5981 6.82748 12.1769 7.45551C11.7557 8.08354 11.1578 8.57263 10.4587 8.86099C9.75967 9.14934 8.99083 9.22402 8.24935 9.07559C7.50787 8.92715 6.82702 8.56227 6.29283 8.02703C5.75865 7.4918 5.39509 6.81024 5.24811 6.06847C5.10113 5.32669 5.17732 4.558 5.46704 3.85951C5.75676 3.16102 6.24703 2.56408 6.87588 2.14411C7.50474 1.72415 8.24396 1.5 9.00016 1.5C10.0153 1.50199 10.9882 1.90664 11.7053 2.62516C12.4224 3.34368 12.8252 4.31736 12.8252 5.3325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIcon);
export default __webpack_public_path__ + "static/media/employeeIcon.dc2f775c824b87230ccfdd041a61b6ab.svg";
export { ForwardRef as ReactComponent };